import { createFileRoute } from '@tanstack/react-router';

import { ApplicatorProfiles } from '@/features/applicator-profiles/ApplicatorProfiles';

export const Route = createFileRoute('/_authenticated/applicator-profiles/')({
  component: ApplicatorProfiles,
});
